import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-attribute-mapping',
  templateUrl: './attribute-mapping.component.html',
  styleUrls: ['./attribute-mapping.component.css']
})
export class AttributeMappingComponent implements OnInit, OnDestroy {
  private _attributeList: any[] = [];
  attributeKeyList: any[] = [];
  attributeValueList: any[] = [];
  excludeReadonlyList: any = ['interface', 'channel'];
  attributeForm: any;
  private _isFormValueChanged: boolean = false;
  private _attributeFormSubscription: Subscription;
  private _afterClosedSubscription: Subscription;
  private _submitAfterClosedSubscription: Subscription;

  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialog: MatDialog,
    private _dialogRef: MatDialogRef<any>
  ) { }

  ngOnInit(): void {
    this._attributeList = this.data.details.apiDetails;
    let dataExpected: any = {};
    if (Array.isArray(this._attributeList)) {
      this._attributeList.forEach(e => {
        dataExpected[e.type] = e;
      });
      this.attributeKeyList = Object.keys(dataExpected);
      this.attributeValueList = Object.values(dataExpected);
    } else {
      this.attributeKeyList = Object.keys(this._attributeList);
      this.attributeValueList = Object.values(this._attributeList);
    }
    this.attributeForm = new FormGroup({});
    this.attributeKeyList.forEach((currentValue: any, index: any) => {
      this.attributeForm.addControl(
        currentValue,
        new FormControl(this.attributeValueList[index])
      );
    });
    this._attributeFormSubscription = this.attributeForm.valueChanges.subscribe(() => this._isFormValueChanged = true);
    if (this.data?.type === 'profile' || this.data?.type === 'object') {
      this.excludeReadonlyList = ['trend', 'value'];
      if (Array.isArray(this._attributeList)) {
        this.excludeReadonlyList = [...this.excludeReadonlyList, ...this.attributeKeyList];
      }
    }
  }
  ngOnDestroy(): void {
    this._attributeFormSubscription?.unsubscribe();
    this._afterClosedSubscription?.unsubscribe();  
    this._submitAfterClosedSubscription?.unsubscribe();  
  }
  checkType(index: any) {
    return typeof this.attributeValueList[index];
  }

  submit() {
    if (this._isFormValueChanged) {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: { msg: 'Are you sure you want to proceed?', type: null },
        disableClose: true
      });
      this._submitAfterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._dialogRef.close({ status: true, value: this.attributeForm.value });
        }
      });
    }
  }

  onObjectDataClick(formControlName: string) {
    const controlName = formControlName;
    let dialogRef = this._dialog.open(AttributeMappingComponent, {
      height: '85%',
      data: { msg: 'Edit attribute mapping', details: { apiDetails: this.attributeForm?.value[formControlName] }, type: 'object' },
      disableClose: true
    });
    this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
      if (result?.status) {
        if (controlName === 'trend') {
          this.attributeForm.controls[controlName].setValue(Object.values(result?.value));
        } else {
          this.attributeForm.controls[controlName].setValue(result?.value);
        }
      }
    });
  }

}